// extracted by mini-css-extract-plugin
export var tickList = "tick_list-module--tickList--dQozO";
export var tickListItem = "tick_list-module--tickListItem--O4L-r";